export const SET_TOOLTIP_DATA = 'SET_TOOLTIP_DATA';
export const CLEAN_TOOLTIP_DATA = 'CLEAN_TOOLTIP_DATA';

export const CREATE_AND_SHOW_TOOLTIP = 'CREATE_AND_SHOW_TOOLTIP';
export const OVER_TOOLTIP = 'OVER_TOOLTIP';
export const DELETE_TOOLTIP = 'DELETE_TOOLTIP';
export const ON_MOUSE_LEAVE_TOOLTIP = 'ON_MOUSE_LEAVE_TOOLTIP';

export const FAVORITE_REQUEST_INIT = 'FAVORITE_REQUEST_INIT';
export const FAVORITE_REQUEST_SUCCESS = 'FAVORITE_REQUEST_SUCCESS';

export const TOOGLE_IS_FAVORITE = 'TOOGLE_IS_FAVORITE';
